import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { RightToolbar } from '@homesusa/core';
import { AddButton } from './add-button.component';
import { ColumnVisibilityButton } from './column-visibility-button.component';
import { ExportButtons } from './export-buttons.component';
import { MultiSelectFilter } from './multi-select-filter.component';
import { RefreshButton } from './refresh-button.component';
import { SearchFilter } from './search-filter/search-filter.component';
import { SelectFilter } from './select-filter.component';
import { SelectPageSize } from './select-page-size/select-page-size.component';

function GridToolbar({
  children,
  hidePageSize,
  title
}: PropsWithChildren<{
  hidePageSize?: boolean;
  title?: string;
}>): JSX.Element {
  return (
    <Toolbar sx={{ padding: { xs: 0, md: 0 } }}>
      <Typography variant='h1'>{title}</Typography>
      <Box sx={{ flexGrow: 1 }} />
      <RightToolbar>
        <Stack direction='row' spacing={0.5} justifyContent='space-between' alignItems='center'>
          {children}
          {hidePageSize ? null : <SelectPageSize />}
        </Stack>
      </RightToolbar>
    </Toolbar>
  );
}

GridToolbar.AddButton = AddButton;
GridToolbar.ExportButtons = ExportButtons;
GridToolbar.SearchFilter = SearchFilter;
GridToolbar.SelectFilter = SelectFilter;
GridToolbar.MultiSelectFilter = MultiSelectFilter;
GridToolbar.RefreshButton = RefreshButton;
GridToolbar.SelectPageSize = SelectPageSize;
GridToolbar.ColumnVisibilityButton = ColumnVisibilityButton;

export { GridToolbar };
